"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
function zipMap(project) {
    return operators_1.map(function (val) { return [val, project(val)]; });
}
exports.zipMap = zipMap;
